import {
  DocumentReference,
  IDeleteAfter,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IPopupNotification } from '@principle-theorem/notifications';
import { IStaffer } from '../staffer/staffer';
import { IMarketingCampaignEntry } from './campaign-entry';
import { IMarketingCampaignRun } from './campaign-run';

export const BULK_ACTION_PAGE_SIZE = 2500;

export enum CampaignBulkActionType {
  Approve = 'approve',
  Remove = 'remove',
  Unenrol = 'unenrol',
}

export enum CampaignBulkActionStatus {
  Created = 'created',
  Pending = 'pending',
  Running = 'running',
  Complete = 'complete',
  Failed = 'failed',
}

export enum CampaignBulkActionCollection {
  Pages = 'pages',
}

export interface ICampaignBulkAction extends ISoftDelete, IDeleteAfter {
  campaignRunRef?: DocumentReference<IMarketingCampaignRun>;
  action: CampaignBulkActionType;
  pageCount: number;
  pageProgress?: Record<string, number>;
  initiatedBy: DocumentReference<IStaffer>;
  status: CampaignBulkActionStatus;
  total: number;
  processed: number;
  errorMessage?: string;
  startedAt?: Timestamp;
  completedAt?: Timestamp;
  notificationRef?: DocumentReference<IPopupNotification>;
}

export interface ICampaignBulkActionPage extends IDeleteAfter {
  entryRefs: DocumentReference<IMarketingCampaignEntry>[];
  status: CampaignBulkActionStatus;
  processed: number;
  total: number;
  pageIndex: number;
  errorMessage?: string;
}
